import DOMPurify from 'dompurify';
import { isEmpty } from 'lodash';
import { Tooltip } from 'tdesign-react';

import { Clip } from '@/components/clip';
import { Question, RequiredIcon } from '@/components/icon';
import SvgIcon from '@/components/tools/svg-icon';

import { FormTitle } from '../form/materials/Title';
import styles from './index.module.less';

export interface LabelDomProps {
  field: any;
  initFormData: any;
  requiredItem?: boolean;
  pageId?: string;
  tipList?: any[];
}

export const labelDom = (
  { field, initFormData, requiredItem, pageId, tipList }: LabelDomProps,
  hasLabel = true,
  fontStyle?: React.CSSProperties,
) => {
  const defaultData = initFormData?.[field.props];

  const required = requiredItem || field?.rules?.some((e: { required: boolean }) => e.required);

  if (hasLabel && (!field.label || field.labelConfig?.notShowLabel)) return null;

  const createMarkup = (html: string) => ({ __html: DOMPurify.sanitize(html) });

  let { tipIcon } = field.labelSetting || {};
  const { tipText } = field.labelSetting || {};
  let singleText = tipIcon ? null : tipText;
  let richText = tipIcon ? tipText : null;
  let custom: string | null = null;
  let btnText = null;

  if (pageId) {
    if (Array.isArray(tipList) && tipList.length > 0) {
      const matchedTip = tipList.find((tip: any) => tip
        && tip.pageId === pageId
        && tip.moduleId === field.props);
      if (matchedTip) {
        ({ hasIcon: tipIcon, singleText, richText, custom, btnText } = matchedTip);
      }
    }
  }

  if (field?.uiOptions?.isFormTitle) {
    return <FormTitle replaceObject={{}} {...field?.uiOptions} title={field?.label} pageId={pageId} />;
  }

  const showTooltip = !!tipIcon && (!!custom || (!!richText && richText !== '<p></p>'));

  const getTooltipContent = () => {
    if (custom) {
      return <div dangerouslySetInnerHTML={createMarkup(custom)} />;
    }
    if (richText && richText !== '<p></p>') {
      return <div dangerouslySetInnerHTML={createMarkup(richText)} />;
    }
    return null;
  };

  return (
    <div
      className={styles.container}
      style={{ ...field?.uiOptions?.labelStyle }}
    >
      <span className={styles.label} style={{ ...fontStyle }}>{field.label}</span>

      {required && <span style={{ marginLeft: 4 }}><RequiredIcon /></span>}

      {singleText && <span className={styles.singleText}>{singleText}</span>}

      {showTooltip && <Tooltip
        content={getTooltipContent()}
        destroyOnClose
        showArrow
        theme="default"
        placement='top-right'
        overlayClassName={custom ? styles.customTooltip : undefined}
        overlayInnerStyle={{ maxWidth: 680 }}
      >
        {btnText
          ? <div className={styles.textTip}>
              <Question className={styles.question} />
              <div>{btnText}</div>
            </div>
          : <Question className={styles.question} />
        }
      </Tooltip>}

      {field.copy && !isEmpty(defaultData) && <Clip post={defaultData}>
        <SvgIcon name="copy" width="14px" height="14px" />
      </Clip>}
    </div>
  );
};
